var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveLu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,2h2v6c0,0.6,0.4,1,1,1c0.3,0,0.5-0.1,0.7-0.3L11,7.4l1.3,1.3C12.5,8.9,12.7,9,13,9c0.1,0,0.3,0,0.4-0.1 C13.8,8.8,14,8.4,14,8V2h6v6c0,0.6,0.4,1,1,1h5v8h2V8c0,0,0,0,0-0.1c0-0.1,0-0.2,0-0.2c0,0,0-0.1,0-0.1c0-0.1-0.1-0.2-0.2-0.3l-6-7 c-0.1-0.1-0.2-0.2-0.3-0.2c0,0-0.1,0-0.1,0C21.3,0,21.2,0,21.1,0c0,0,0,0-0.1,0H5C4.4,0,4,0.4,4,1v30c0,0.6,0.4,1,1,1h14v-2H6V2z  M22,3.7L24.8,7H22V3.7z M12,2v3.6l-0.3-0.3c-0.4-0.4-1-0.4-1.4,0L10,5.6V2H12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,18c-3.9,0-7,3.1-7,7s3.1,7,7,7s7-3.1,7-7C32,21.1,28.9,18,25,18z M25,30c-2.8,0-5-2.2-5-5s2.2-5,5-5 s5,2.2,5,5C30,27.8,27.8,30,25,30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.7,24.3l-2.8-2.8l-1.4,1.4l1.1,1.1H21v2h4.6l-1.1,1.1l1.4,1.4l2.8-2.8C29.1,25.3,29.1,24.7,28.7,24.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveLu);
export default __webpack_public_path__ + "static/media/move-lu.e34b05e85bd18c8c9ac311febf24ce95.svg";
export { ForwardRef as ReactComponent };